import { useEffect, useState } from "react";
import { Trophy, X } from "lucide-react";
import { useLang } from "../../i18n/LangContext";
import { useFooterVisible, useScrolledPast, useIsMobile } from "./FooterParts";

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
const amount = () => (Math.floor(Math.random() * 190) + 5) * 500;

const makeWin = (t) => ({
  id: Date.now(),
  name: `${pick(t.names)} ${pick(t.initials)}.`,
  city: pick(t.cities),
  game: pick(t.games),
  amount: amount().toLocaleString("en-IN"),
});

export const WinnerPopup = () => {
  const { winner: t } = useLang().t;
  const [win, setWin] = useState(null);
  const [closed, setClosed] = useState(false);
  const footerVisible = useFooterVisible();
  const scrolledFar = useScrolledPast(650);
  const scrolled = !useIsMobile() || scrolledFar;

  useEffect(() => {
    if (closed) return;
    let hideTimer;
    const show = () => {
      setWin(makeWin(t));
      hideTimer = setTimeout(() => setWin(null), 5000);
    };
    const first = setTimeout(show, 4000);
    const loop = setInterval(show, 11000);
    return () => { clearTimeout(first); clearInterval(loop); clearTimeout(hideTimer); };
  }, [t, closed]);

  if (!win || closed || footerVisible || !scrolled) return null;
  return (
    <div key={win.id} data-testid="winner-popup"
      className="winner-in glass fixed left-3 right-3 top-[120px] z-30 flex max-w-xs items-center gap-3 rounded-2xl border border-[#D4AF37]/50 p-2.5 pr-8 shadow-[0_0_30px_rgba(212,175,55,0.25)] sm:bottom-6 sm:left-6 sm:right-auto sm:top-auto sm:z-50 sm:w-full sm:p-3">
      <div className="grid h-9 w-9 shrink-0 place-items-center rounded-full bg-gradient-to-br from-[#F3D77A] to-[#9A7B2C] text-black sm:h-11 sm:w-11">
        <Trophy size={18} />
      </div>
      <div className="min-w-0 text-xs leading-snug">
        <p className="truncate font-semibold text-white" data-testid="winner-name">{win.name} · {win.city}</p>
        <p className="text-zinc-400">{t.won} <span className="font-bold text-[#D4AF37]" data-testid="winner-amount">₹{win.amount}</span> {t.on} {win.game}</p>
        <p className="mt-0.5 text-[10px] uppercase tracking-widest text-emerald-400">{t.just}</p>
      </div>
      <button onClick={() => setClosed(true)} data-testid="winner-close" aria-label="Close" className="absolute right-2 top-2 text-zinc-500 hover:text-white">
        <X size={14} />
      </button>
    </div>
  );
};
